module.exports = __webpack_public_path__ + "static/media/service_tile_handbike.91da86ff.jpg";